import request from '@/utils/request'

let ProductApi = {
    /* sku管理 */
    skuList(data){
        return request._get('/shop/plus.skucoupon.sku/index',data);
    },
     /* sku折扣价格管理 */
    editSku(data){
        return request._get('/shop/plus.skucoupon.sku/edit',data);
    },
}

export default ProductApi;



// WEBPACK FOOTER //
// ./src/api/skucoupon.js